import { useMemo } from 'react';
import { useAuth, useEventUserRole } from '@shared/components/AuthProvider';
import { useIsHotelBlockAccommodationsFlagEnabled } from '@apps/admin/common/hooks/useIsHotelBlockAccommodationsFlagEnabled';

export function useShouldHideRoomBlockPreview() {
  const { isSuperAdmin } = useAuth();
  const { isAdmin, fetching } = useEventUserRole();
  const isHotelBlockAccommodationsFlagEnabled = useIsHotelBlockAccommodationsFlagEnabled();

  const hideAccomPreviewUntilFlagEnabled = useMemo<boolean>(() => {
    if (fetching) {
      return true;
    }
    if (isSuperAdmin) {
      return false;
    }

    return isAdmin && !isHotelBlockAccommodationsFlagEnabled;
  }, [fetching, isSuperAdmin, isAdmin, isHotelBlockAccommodationsFlagEnabled]);

  return { hideAccomPreviewUntilFlagEnabled };
}
